import React from "react";
import PT from "prop-types";
import { Button } from "_c/button";
import LocaleSwitch from "../LocaleSwitch";
import { analyticsAction } from "@/utils/analytics";
import { ToggleButtonGroup, ToggleButton } from "_c/ToggleButton";

const roleNs = "login:reg_roles.";

const RegisterFormRole = (props) => {
  const onSubmit = (e) => {
    e.preventDefault();
    props.nextStep();
    let action;
    if (props.form.is_master) action = "pro";
    else if (props.form.is_saloon_owner) action = "crm";
    else if (props.form.is_client) action = "client";
    else if (props.form.is_todo) action = "todo";
    if (action) {
      analyticsAction({
        category: "reg",
        action: "type_" + action + "_chosen",
      });
    }
  };
  const updateRole = (role) => {
    props.updateForm({
      is_client: false,
      is_todo: false,
      is_master: false,
      is_saloon_owner: false,
      ...role,
    });
  };
  const canGoNext = props.isRoleSelected;
  return (
    <form onSubmit={onSubmit}>
      <LocaleSwitch
        css={`
          margin-bottom: 10px;
        `}
        showFullNameOfActiveLanguage
      />
      <h4
        css={`
          margin: 0;
          margin-bottom: 15px;
          color: var(--font-color-main);
        `}
      >
        {props.t("login:reg_role_head")}
      </h4>
      <div
        css={`
          margin-bottom: 20px;
          width: 300px;
        `}
      >
        <ToggleButtonGroup
          value={
            props.form.is_client ? "client" : props.form.is_master && "master"
          }
          onChange={(value) => {
            updateRole({
              is_client: value === "client",
              is_master: value === "master",
            });
          }}
        >
          <ToggleButton value="client">
            {props.t(roleNs + "toggle_consumer")}
          </ToggleButton>
          <ToggleButton value="master">
            {props.t(roleNs + "toggle_producer")}
          </ToggleButton>
        </ToggleButtonGroup>
      </div>
      <Button disabled={!canGoNext} type="submit" small greenish>
        {props.t("common:next")}
      </Button>
    </form>
  );
};
RegisterFormRole.propTypes = {
  form: PT.object.isRequired,

  nextStep: PT.func.isRequired,
  t: PT.func.isRequired,
};

export default RegisterFormRole;
